import { supabase } from '@/integrations/supabase/client';

/**
 * Rate limiting helper for case study views
 * Only allows one view per case study per session per hour
 */
export function canRecordCaseStudyView(caseStudyId: string): boolean {
  // Guard against SSR - localStorage is not available on the server
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return false;
  }

  const key = `case-study-view-${caseStudyId}`;
  const lastView = localStorage.getItem(key);
  const now = Date.now();

  if (lastView && now - parseInt(lastView) < 60 * 60 * 1000) {
    return false;
  }

  localStorage.setItem(key, now.toString());
  return true;
}

/**
 * Records a case study view in the database
 * Mirrors the portfolio item view tracking implementation
 */
export async function recordCaseStudyView(
  profileId: string,
  caseStudyId: string,
  viewerId: string | null = null
): Promise<void> {
  try {
    await supabase.from('case_study_views').insert([
      {
        profile_id: profileId,
        case_study_id: caseStudyId,
        viewer_id: viewerId,
      },
    ]);
    
    console.log(`Case study view recorded: ${caseStudyId} by ${viewerId || 'anonymous'}`);
  } catch (error) {
    console.error('Error recording case study view:', error);
  }
}
